.earningsDrawerContentRoot {
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.styledSummaryTableWrapper {
  tbody tr:last-child {
    td,
    th {
      border-bottom: none;
    }
  }
}

.surpriseWrapper {
  &.positive {
    color: var(--viz-bullish);
  }

  &.negative {
    color: var(--viz-bearish);
  }

  &.disabled {
    color: var(--text-disabled);
  }
}
